import { render } from "./JobList.vue?vue&type=template&id=de5aba16&scoped=true&lang=true"
import script from "./JobList.vue?vue&type=script&lang=js"
export * from "./JobList.vue?vue&type=script&lang=js"

import "./JobList.vue?vue&type=style&index=0&id=de5aba16&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5aba16"]])

export default __exports__